window.addEventListener('click', e => {
  const target = e.target;

  if (
    target.classList.contains('js-footer-menu-title') &&
    window.innerWidth < 768
  ) {
    target.classList.toggle('footer__menus-title--expanded');
  }
});

window.addEventListener('keyup', e => {
  const target = e.target

  if (
    target.classList &&
    target.classList.contains('js-newsletter-email')
  ) {
    const eventName = e.key === 'Enter' ? 'submit': 'keyup'
    customFormValidator(target.closest('.js-newsletter-form'), eventName)
  }
})

window.addEventListener('submit', e => {
  const target = e.target

  if (
    target.classList &&
    target.classList.contains('js-newsletter-form')
  ) {
    customFormValidator(target, 'submit')
  }
})
